import * as z from "zod";

/** A signed amount in fractional minor units, as a decimal integer string. */
export const FractionalAmountSchema = z.string().regex(/^-?\d+$/);
